<template>
  <div
    id="ny-rute"
    @click="onClick"
  >
    <span>Opret en ny rute</span>
    <Plus />
  </div>
</template>

<script>
import Plus from '@/components/Icons/FilledCirclePlus';
export default {
  name: 'ny-rute',
  components: { Plus },
  methods: {
    onClick: function() {
      this.$router.push('/edit');
    },
  },
};
</script>

<style lang="scss" scoped>
#ny-rute {
  color: #0f1c70;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.7);
  border: 2px dashed rgba(15, 28, 112, 0.7);
  max-width: 725px;
  width: 85%;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  cursor: pointer;
  border-radius: 6px;
  transition: 0.2s;
  &:hover {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 1);
  }
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  #ny-rute {
    padding: 0 30px;
  }
}
</style>
